module.exports = __webpack_public_path__ + "new0.jpg?3d5097a203515192e52e2d09e79de1e5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new0.jpg
// module id = 82
// module chunks = 0